import { makeActionCreator } from '../../../utilities'
import { SpecialReportsConstants } from './specialReports.constants'

export const saveSpecialReport = makeActionCreator(SpecialReportsConstants.SAVE_SPECIAL_REPORT)
export const setCurrentStep = makeActionCreator(SpecialReportsConstants.SET_CURRENT_STEP, '__currentStep')
export const setCurrentSubStep = makeActionCreator(SpecialReportsConstants.SET_CURRENT_SUB_STEP, '__currentSubStep')
export const setNarrative = makeActionCreator(SpecialReportsConstants.SET_NARRATIVE, 'narrative')
export const setSubject = makeActionCreator(SpecialReportsConstants.SET_SUBJECT, 'subject')
export const setDateOccurred = makeActionCreator(SpecialReportsConstants.SET_DATE_OCCURRED, 'dateOccurred')
export const setAuthor = makeActionCreator(SpecialReportsConstants.SET_AUTHOR, 'author')
export const setSupervisor = makeActionCreator(SpecialReportsConstants.SET_SUPERVISOR, 'supervisor')
export const setPersonnelIssue = makeActionCreator(SpecialReportsConstants.SET_PERSONNEL_ISSUE, 'personnelIssue')
export const setIsUrgent = makeActionCreator(SpecialReportsConstants.SET_IS_URGENT, 'isUrgent')
export const setIsFlagReport = makeActionCreator(SpecialReportsConstants.SET_IS_FLAG_REPORT, 'isFlagReport')
export const setCrew = makeActionCreator(SpecialReportsConstants.SET_CREW, 'crew')
export const setBase = makeActionCreator(SpecialReportsConstants.SET_BASE, 'base')
export const setUnit = makeActionCreator(SpecialReportsConstants.SET_UNIT, 'unit')
export const setCategories = makeActionCreator(SpecialReportsConstants.SET_CATEGORIES, 'categories')
export const setSubCategories = makeActionCreator(SpecialReportsConstants.SET_SUB_CATEGORIES, 'subCategories')
export const setCustomQuestions = makeActionCreator(SpecialReportsConstants.SET_CUSTOM_QUESTIONS, 'customQuestions')
export const setAutoEmail = makeActionCreator(SpecialReportsConstants.SET_AUTO_EMAIL, 'autoEmail')
export const setExtraEmail = makeActionCreator(SpecialReportsConstants.SET_EXTRA_EMAIL, 'extraEmail')
export const setReportType = makeActionCreator(SpecialReportsConstants.SET_REPORT_TYPE, 'reportType')
export const setRuleId = makeActionCreator(SpecialReportsConstants.SET_RULE_ID, 'ruleId')
export const resetSpecialReportsState = makeActionCreator(SpecialReportsConstants.RESET_SPECIAL_REPORTS)
export const resetSpecialReportsOnChartExit = makeActionCreator(
  SpecialReportsConstants.RESET_SPECIAL_REPORTS_ON_CHART_EXIT
)
export const initializeSpecialReport = makeActionCreator(SpecialReportsConstants.INITIALIZE_SPECIAL_REPORT)
export const deleteSpecialReport = makeActionCreator(SpecialReportsConstants.DELETE_SPECIAL_REPORT, 'id')
export const setSpecialReportsList = makeActionCreator(
  SpecialReportsConstants.SET_SPECIAL_REPORTS_LIST,
  'specialReportsList'
)
export const getSpecialReports = makeActionCreator(SpecialReportsConstants.GET_SPECIAL_REPORTS)
export const setCompleted = makeActionCreator(SpecialReportsConstants.SET_COMPLETED, 'completed')
